export enum DeploymentModes {
  Management = 'Management',
  BulkDeploy = 'BulkDeploy',
  BulkUndeploy = 'BulkUndeploy',
  Single = 'Single',
  Bulk = 'Bulk',
  Undeploy = 'Undeploy',
}
